<template>
  <b-modal
    id="BasedOnAplication"
    cancel-variant="outline-secondary"
    :ok-title="$t('save')"
    :cancel-title="$t('general.close')"
    centered
    size="xl"
    no-close-on-backdrop
    :title="$t('add')"
    :ok-disabled="disableSaveBtnIfNeeded()"
    @ok="onSave()"
  >
  <div>
      <div class="d-flex justify-space-between">
        <div class="d-flex w-100">
          <div class="mr-1">
            <AppSearchInput
              v-model="filter.search"
              :label="$t('search') + ':'"
              :placeholder="$t('search') + '...'"
              @callback="onFiltered"
            />
          </div>
        </div>
        <div
          class="d-flex align-items-center ml-1"
          style="margin-top: 10px;"
        >
          <b-form-radio-group
            id="radio-group-1"
            v-model="card"
            class="list item-view-radio-group"
            :options="itemViewOptions"
            buttons
            button-variant="outline-primary"
          >
          </b-form-radio-group>
        </div>
      </div>
      

      <b-table
        v-if="card"
        id="user-table"
        class="px-1 rounded mt-1"
        :fields="fields"
        :items="applicationMaterial.results"
        show-empty
        :tbody-tr-class="['tableRowClass']"
        small
        responsive
        :empty-text="$t('empty_text')"
      >
        <template #head()="props">
          <span>{{ $t(props.label) }}</span>
        </template>


        <template #cell(storage)="{ value }">
          <span v-if="value && value.title">
              {{ value.title }}
          </span>
        </template>

        <template #cell(product)="{ item }">
          <b-badge
            v-for="(item2, index) in item.goods"
            :key="index"
            class="mr-50"
          >
          <span v-if="item2 && item2.good && item2.good.product && item2.good.product.title">
            {{ item2.good.product.title }}
          </span>
          </b-badge>
        </template>


        <template #cell(good)="{ item }">
          <b-badge
            v-for="(item2, index) in item.goods"
            :key="index"
            class="mr-50"
          >
            <span v-if="item2 && item2.good && item2.good.value && item2.count">
              {{ item2.good.value }}  - {{ $_formatPriceMixin(item2.count) }}
            </span>
          </b-badge>
        </template>

        <template #cell(requirement_type)="{ value }">
          <b-badge
            v-if="value"
            variant="success"
          >
            {{ value }}
          </b-badge>
        </template>

        <template #cell(actions)="props">
          <div class="d-flex align-items-center justify-content-center">
             <b-form-checkbox
              v-model="props.item.checked"
              @input="ItemChecked(props.item)"
              :disabled="disableCheckboxIfNeeded(props.item)"
            ></b-form-checkbox>
          </div>
        </template>

      </b-table>

      <Pagination
        v-if="card"
        class="w-100"
        :params="paramsMaterials"
        :rows="applicationMaterial.count"
        @refresh="onFiltered"
      />





      <b-table
        v-if="!card"
        id="user-table"
        class="px-1 rounded mt-1"
        :fields="fields"
        :items="applicationInstrument.results"
        show-empty
        :tbody-tr-class="['tableRowClass']"
        small
        responsive
        :empty-text="$t('empty_text')"
      >
        <template #head()="props">
          <span>{{ $t(props.label) }}</span>
        </template>

        <template #cell(storage)="{ value }">
          <span v-if="value && value.title">
              {{ value.title }}
          </span>
        </template>


        <template #cell(good)="{ item }">
          <b-badge
            v-for="(item2, index) in item.instruments"
            :key="index"
            class="mr-50"
          >
            <span v-if="item2 && item2.instrument && item2.instrument.title">
              {{ item2.instrument.title }} - {{ $_formatPriceMixin(item2.count) }}
            </span>
          </b-badge>
        </template>


        <template #cell(product)="{ item }">
          <b-badge
            v-for="(item2, index) in item.instruments"
            :key="index"
            class="mr-50"
          >
            <span v-if="item2 && item2.instrument && item2.instrument.type && item2.instrument.type.title">
              {{ item2.instrument.type.title }}
            </span>
          </b-badge>
        </template>

        <template #cell(requirement_type)="{ value }">
          <b-badge
            v-if="value"
            variant="success"
          >
            {{ value }}
          </b-badge>
        </template>

        <template #cell(actions)="props">
          <div class="d-flex align-items-center justify-content-center">
            <b-form-checkbox
              v-model="props.item.checked"
              @input="ItemChecked2(props.item)"
              :disabled="disableCheckboxIfNeeded(props.item)"
            ></b-form-checkbox>
          </div>
        </template>

      </b-table>

      <Pagination
        v-if="!card"
        class="w-100"
        :params="paramsInstruments"
        :rows="applicationInstrument.count"
        @refresh="onFiltered"
      />

    </div>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BButton,
  BTable,
  VBTooltip,
  BBadge,
  BFormRadio,
  BFormRadioGroup,
  BModal,
  VBModal,
  BFormCheckbox
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import AppSearchInput from '@/components/AppSearchInput.vue'
import VueDataPicker from '@/components/VueDatePicker.vue'
import Pagination from '@/components/Pagination.vue'
import areYouSure from '@/mixins/areYouSure'
import priceFormatMixin from '@/mixins/priceFormatMixin';

export default {
  components: {
    AppSearchInput,
    VueDataPicker,
    Pagination,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BButton,
    BTable,
    BBadge,
    BFormRadio,
    BFormRadioGroup,
    BModal,
    VBModal,
    BFormCheckbox
  },
  directives: {
    'b-tooltip': VBTooltip,
    'b-modal': VBModal,
  },
  mixins: [areYouSure, priceFormatMixin],
  data() {
    return {
      choosedMaterials: [],
      choosedInstruments: [],
      count: 1,
      paramsMaterials: {
        purchase: true,
        page_size: 10,
        page: 1,
      },
      paramsInstruments: {
        purchase: true,
        page_size: 10,
        page: 1,
      },
      card: true,
      filter: {
        search: '',
        requirement_type: null,
      },
      filterWorking: false,
      itemViewOptions: [
        {
          text: this.$t('reference.material'),
          value: true,
        },
        {
          text: this.$t('reference.instrument'),
          value: false,
        },
      ],
      fields: [
        {
          label: '№',
          key: 'id',
          thClass: 'tableHeadClass',
        },
        {
          label: 'destination_warehouse',
          key: 'storage',
          thClass: 'tableHeadClass',
          tdClass: 'text-center',
        },
        {
          label: 'table.product_type',
          key: 'product',
          thClass: 'tableHeadClass',
        },
        {
          label: 'product',
          key: 'good',
          thClass: 'tableHeadClass',
        },
        {
          label: 'general.created_at',
          key: 'created_at',
          formatter: (data) => this.$dayjs(data).format("DD.MM.YYYY"),
          thClass: 'tableHeadClass',
        },
        {
          label: 'actions',
          key: 'actions',
          thClass: 'tableHeadClass',
        },
      ],
    }
  },
  watch: {
  },
  computed: {
    ...mapState('application', ['applicationMaterial', 'applicationInstrument']),

    checkedMaterialIds: {
      get: function () {
        return this.$store.state.agrements.checkedMaterialIds;
      },
      set: function (newValue) {
        this.$store.commit('agrements/SET_CHECKED_MATERIAL_IDS', newValue)
      }
    },
    checkedInstrumentIds: {
      get: function () {
        return this.$store.state.agrements.checkedInstrumentIds;
      },
      set: function (newValue) {
        this.$store.commit('agrements/SET_CHECKED_INSTRUMENT_IDS', newValue)
      }
    },
    materialAndInstrumentApplications: {
      get: function () {
        return this.$store.state.agrements.materialAndInstrumentApplications;
      },
      set: function (newValue) {
        this.$store.commit("agrements/SET_MATERIAL_AND_INSTRUMENT_ITEMS", newValue);
      },
    },

  },
  async mounted() {
    await this.FETCH_APPLICATIONS_MATERIAL(this.paramsMaterials)
    await this.FETCH_APPLICATION_INSTRUMENT(this.paramsInstruments)

    this.checkedMaterialIdsForEdit = []
    this.checkedInstrumentIdsForEdit = []
  },
  methods: {
    ...mapActions('application', [
      'FETCH_APPLICATIONS_MATERIAL',
      'FETCH_APPLICATION_INSTRUMENT',
    ]),



    async onFiltered() {
      this.filterWorking = true

      if (this.card) {
        await this.FETCH_APPLICATIONS_MATERIAL({ ...this.filter, ...this.paramsMaterials })


        this.applicationMaterial.results.forEach((elem) => {
          this.checkedMaterialIds.forEach((id) => {
            if(elem.id == id){
              elem.checked = true
             }
          })
        })

      } else {
        await this.FETCH_APPLICATION_INSTRUMENT({ ...this.filter, ...this.paramsInstruments })


        this.applicationInstrument.results.forEach((elem) => {
          this.checkedInstrumentIds.forEach((id) => {
            if(elem.id == id){
              elem.checked = true
             }
          })
        })

      }

      this.filterWorking = false
    },


    disableSaveBtnIfNeeded(){
      let status = true

      if((this.checkedMaterialIds && this.checkedMaterialIds.length != 0) || (this.checkedInstrumentIds && this.checkedInstrumentIds.length != 0)){
        status = false
      }

      return status
    },


    async onSave(){
      let array = this.choosedMaterials.filter((elem, index) => {
        if(elem.checked == true){
          return elem
        }
      })


      let array2 = this.choosedInstruments.filter((elem, index) => {
        if(elem.checked == true){
          return elem
        }
      })
      array = array.concat(array2);





      // ==================== Removing duplicate applications ====================
      let splicingIndexes = [];
      array.forEach((elem, index) => {
        this.materialAndInstrumentApplications.forEach((elem2, index2) => {
          if(elem2.id == elem.id){
            splicingIndexes.push(index)
          }
        })
      })

      splicingIndexes.sort().reverse()
      
      splicingIndexes.forEach((elem) => {
        array.splice(elem, 1)
      })
      // ==================== Removing duplicate applications ====================




      this.checkedMaterialIds = []
      this.choosedMaterials = []
      this.checkedInstrumentIds = []
      this.choosedInstruments = []


      this.applicationMaterial.results.forEach((elem) => {
        elem.checked = false
      })
      this.applicationInstrument.results.forEach((elem) => {
        elem.checked = false
      })



      let arrayTotal = this.materialAndInstrumentApplications.concat(array)
      this.$store.commit('agrements/SET_MATERIAL_AND_INSTRUMENT_ITEMS', arrayTotal)
      this.$bvModal.hide('BasedOnAplication')
    },




    ItemChecked(item){
      if(this.filterWorking == false){
        if(this.checkedMaterialIds && !this.checkedMaterialIds.includes(item.id)){
          this.checkedMaterialIds.push(item.id)
          this.choosedMaterials.push(item)
        }else if(item.checked == false && this.checkedMaterialIds){
          let index = this.checkedMaterialIds.findIndex((id) => id == item.id)
          this.checkedMaterialIds.splice(index, 1)
          this.choosedMaterials.splice(index, 1)
        }
      }
    },



    ItemChecked2(item){
      if(this.filterWorking == false){
        if(item.checked && this.checkedInstrumentIds && !this.checkedInstrumentIds.includes(item.id)){
          this.checkedInstrumentIds.push(item.id)
          this.choosedInstruments.push(item)
        }else if(item.checked == false && this.checkedInstrumentIds){
          let index = this.checkedInstrumentIds.findIndex((id) => id == item.id)
          this.checkedInstrumentIds.splice(index, 1)
          this.choosedInstruments.splice(index, 1)
        }
      }
    },




    disableCheckboxIfNeeded(item){
      let status = true;

      if(item.goods){
        item.goods.forEach((elem) => {
          if(elem.quantity_sum < elem.count){
            status = false
          }
        })
      }else if (item.instruments){
        item.instruments.forEach((elem) => {
          if(elem.quantity_sum < elem.count){
            status = false
          }
        })
      }
      return status
    }








  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

#user-table {
  border-collapse: separate;
  border-spacing: 0 1rem;
}

#user-table .tableRowClass {
  background: white;
  transform: translateY(5px);
  transition: all 0.5s ease-in-out;
  text-align: center;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

  td {
    border-top: 0;
    padding: 20px !important;

    &:first-child {
      border-top-left-radius: 0.5rem;
      border-bottom-left-radius: 0.5rem;
    }

    &:last-child {
      border-top-right-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
    }
  }
}


.dark-layout #radio-group-1 span{
  color: white !important;
}

//  кнопка переключения между заявками и инструментами
[dir] .btn-outline-primary:not(:disabled):not(.disabled).active {
  background-color: #5a9cd9;
  color: white;
}

#user-table .tableRowClass:hover {
  transform: translateY(0);
}

#user-table .tableHeadClass {
  background: none !important;
  border: none !important;
}

#user-table .tableRowClass:hover {
  .tableTitle {
    color: #7367f0 !important;
  }
}

.tableHeadClass {
  text-align: center;
  padding-left: 0 !important;
}
</style>
